import React from 'react';
import { Layout, HorizontalFormContact, GetInfo } from '../components';

const Home = () => {
  return (
    <div className="Home">
      <Layout bannerId={66}>
        <HorizontalFormContact/>
        <GetInfo id={133}/>
      </Layout>
    </div>
  );
};

export default Home;
